<template>
    <h2>
        {{ data.heading }}
    </h2>
</template>

<script>
    export default {
        name: 'heading',
        props: ['data']
    }
</script>



// WEBPACK FOOTER //
// Heading.vue?d0955706